(() => {
  document.querySelectorAll('[data-icon-page]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const stage = root.querySelector('.icon-pdp__image');
    const dialog = root.querySelector('[data-icon-dialog]');
    const size = root.querySelector('[data-icon-size]');
    const galleries = [...root.querySelectorAll('[data-icon-gallery]')];
    function select(button) {
      button.closest('[data-icon-gallery]').querySelectorAll('[data-icon-image]').forEach(item => {
        item.setAttribute('aria-pressed', String(item === button));
        item.classList.toggle('active', item === button);
      });
      const image = button.querySelector('img');
      stage.src = image.src;
      stage.alt = image.alt;
    }
    function sync() {
      root.querySelector('[data-icon-enquiry-size]').value = size.value;
      const selected = root.querySelector('input[name="icon-design"]:checked');
      root.querySelector('[data-icon-enquiry-design]').value = selected.closest('label').querySelector('strong').textContent;
      root.querySelectorAll('[data-icon-format]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.iconFormat === size.value)));
    }
    root.querySelectorAll('[data-icon-image]').forEach(button => button.addEventListener('click', () => select(button)));
    root.querySelectorAll('input[name="icon-design"]').forEach(input => input.addEventListener('change', () => {
      galleries.forEach(group => { group.hidden = group.dataset.iconGallery !== input.value; });
      root.querySelectorAll('[data-icon-editorial]').forEach(group => { group.hidden = group.dataset.iconEditorial !== input.value; });
      select(galleries.find(group => group.dataset.iconGallery === input.value).querySelector('[data-icon-image]'));
      sync();
    }));
    size.addEventListener('change', sync);
    root.querySelectorAll('[data-icon-format]').forEach(button => button.addEventListener('click', () => { size.value = button.dataset.iconFormat; sync(); }));
    root.querySelector('[data-icon-zoom]').addEventListener('click', () => { const image = dialog.querySelector('img'); image.src = stage.src; image.alt = stage.alt; dialog.showModal(); });
    root.querySelector('[data-icon-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    sync();
  });
})();
